// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wczRfPbj1EifDefTKPgg{min-height:unset;max-height:unset;height:100%}.wczRfPbj1EifDefTKPgg .emms1yesAb6YurtP69s6{overflow:hidden}`, "",{"version":3,"sources":["webpack://./services/client/src/components/dashboardGraphs/IssuesNumbers/components/NumberOfIssues/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,gBAAA,CACE,gBAAA,CACA,WAAA,CACF,4CACE,eAAA","sourcesContent":[".grid {\n  min-height: unset;\n    max-height: unset;\n    height: 100%;\n  .column {\n    overflow: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `wczRfPbj1EifDefTKPgg`,
	"column": `emms1yesAb6YurtP69s6`
};
export default ___CSS_LOADER_EXPORT___;
